import { CircularProgress, Typography } from '@material-ui/core';
import React, { useEffect, useState } from 'react'
import http from "../http";

const supportedLocales = [
    'fr-ca',
    'en-ca',
    'es-mx',
    'en-us',
    'en-au',
    'en-hk',
    'en-in',
    'ja-jp',
    'en-nz',
    'en-be',
    'fr-be',
    'de-de',
    'en-dk',
    'es-es',
    'fr-fr',
    'en-fi',
    'en-hu',
    'en-ie',
    'it-it',
    'en-nl',
    'en-no',
    'de-at',
    'pt-pt',
    'ru-ru',
    'en-se',
    'de-ch',
    'fr-ch',
    'it-ch',
    'en-uk'
]

const inIframe = () => {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}

const url = () => {
    switch (window.location.origin) {
        case 'https://nobelreturns.nobelbiocare.com':
            return 'https://store.nobelbiocare.com'
        case 'https://nobelreturns.sta.platform.dental':
            return 'https://nobi-mg2.sta.platform.dental'
        default:
            return 'https://nobi-mg2.dev.platform.dental'
    }
}

const redirect = (country: string, lang: string) =>
    window.location.href = `${url()}/${country}/${lang}/customer/account/login/`

const doRedirect = () => {
    if (!inIframe()) return redirect('international', 'en')

    const locale = navigator.languages.find((l) => supportedLocales.includes(l.toLowerCase()))

    if (locale) {
        const [lang, country] = locale.toLowerCase().split('-')
        return redirect(country, lang)
    } else {
        return redirect('international', 'en')
    }
}

const LoginCheck: React.FC = ({ children }) => {
    const [valid, setValid] = useState(false);

    useEffect(() => {
        http.get(`/api/login`)
            .then(({ data }) => {
                if (data.isLoggedIn) {
                    if (data.token) {
                        http.defaults.headers["Authorization"] = "Bearer " + data.token;
                        localStorage.setItem("token", data.token)
                    }
                    setValid(true);
                } else {
                    doRedirect()
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) doRedirect()
            })
    }, []);

    return valid
        ? <>{children}</>
        : <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100vw', height: '100vh', flexDirection: 'column', gap: 30 }}>
            <Typography variant='h4' color='primary'>Nobel Biocare returns</Typography>

            <CircularProgress size='3rem' />

            <p>Loading...</p>
        </div>
}

export default LoginCheck
